const { keyMirror } = window.EdocatUtils;

export default keyMirror(['ON_CHANGE', 'HIGHLIGHT_ERRORS', 'PROMISE_SUBMIT', 'SET_READY_FOR_SUBMIT']);
